
import React, { useState, useEffect } from 'react';
import Layout from 'Layout'
import './styles.scss'
import { timeZones } from './timezoneList';
import { toast } from 'react-toastify';
import { mixPostV1 } from "services/mixin";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAccount, useDisconnect } from 'wagmi'
import { Connection } from '../../wagmi_config/connector';
import { WalletOptions } from '../../wagmi_config/wallet-options';
import { updateUidAndAddress, useBalanceOf, useCheckIsHaveNFT } from '../../wagmi_config/function/13w';
import { Helmet } from 'react-helmet-async';
import TelegramButton from 'components/Account/TelegramButton';
import { API_URL } from 'env';

const AccountInfoPage: React.FC = () => {
    const { t } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const languageUser = user.language || 'en';
    const { disconnect } = useDisconnect()
    const { isConnected, address } = useAccount()
    const [isUpdated, setIsUpdated] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userId, setUserId] = useState('');
    const [language, setLanguage] = useState(languageUser);
    const [timeZone, setTimeZone] = useState('');

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            const userObject = JSON.parse(userData)
            setLastName(userObject.last_name)
            setFirstName(userObject.first_name)
            setUserId(userObject.id)
        }
    }, [])


    async function handleSubmit() {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const res = await mixPostV1(`/api/v1/be/user/${user.id}`, {
            language,
            first_name: firstName,
            last_name: lastName,
            _method: 'PUT'
        });
        if (res.status) {
            localStorage.setItem('user', JSON.stringify(res.data));
            window.location.reload();
        } else {
            toast.error(res.message || 'Update failed');
        }
    }

    async function getInfo() {
        const res = await fetch(API_URL+`/api/v1/be/13w-challenges/info`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        
    }

    function ConnectWallet() {
        if (isConnected) return <Connection />
        return <WalletOptions />
    }



    return (
        <Layout>
            <Helmet>
                <title>{t('AccountInformation')} - LUMIR</title>
                <meta name="description" content="Manage your account information on LUMIR." />
            </Helmet>
            <>
                <nav className="breadcrumb__container mb-3">
                    <div className="breadcrumb__gradient breadcrumb__gradient--left" data-gradient="left" style={{ display: 'none' }}></div>
                    <ul className="breadcrumb" data-breadcrumb-scroll-container="">
                        <li className="breadcrumb-item"><a href="/accounts-overview">{t("Trader")}</a></li>
                        <li className="breadcrumb-item ">
                            <a href="/profile">
                                {t("Profile")}
                            </a>
                        </li>
                        <li className="breadcrumb-item active">{t('PersonalInformation')}</li>
                    </ul>
                    <div className="breadcrumb__gradient breadcrumb__gradient--right" data-gradient="right" style={{ display: 'none' }}></div>
                </nav>

                <div className="section-header mb-4">
                    <div className="section-title">
                        <div className="section-title__title-wrap">
                            <div className="section-title__icon">
                                <i className="fi fi--user fi--themed"></i>
                            </div>
                            <div className="section-title--main">{t("Profile")}</div>
                        </div>
                    </div>
                    <div className="section-header__tabs">
                        <ul className="nav nav-tabs">
                            <li className="nav-item">
                                <Link to="/profile" className="nav-link ">
                                    <span className="nav-link__label">{t('PersonalInformation')}</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/profile/account" className="nav-link active">
                                    <span className="nav-link__label">{t('AccountInformation')}</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/profile/security" className="nav-link ">
                                    <span className="nav-link__label">{t('Security')}</span>
                                </Link>
                            </li>
                            {/* <li className="nav-item">
                                <Link to="/profile/teams" className="nav-link ">
                                    <span className="nav-link__label">{t("Teams")}</span>
                                </Link>
                            </li> */}
                            <li className="nav-item">
                                <Link to="/profile/affiliate" className="nav-link ">
                                    <span className="nav-link__label">{t('Affiliates')}</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <a href="/profile/inventory" className="nav-link ">
                                    <span className="nav-link__label">{t('Inventory')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <Link to="#" data-notification-target="nav-profile-identity" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('LUMIRIdentity')}</span>
                                </Link>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('EmailNewsletters')}</span>
                                </a>
                            </li>
                            <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                                    <span className="nav-link__label">{t('LUMIRPoints')}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="portlet mt-3 mb-4 p-4">
                    <div className="flex flex-row justify-start items-center px-4">
                        <ConnectWallet />
                    </div>

                    <div className="flex items-center gap-2">
                        {userId && <TelegramButton userId={userId} />}
                    </div>
                </div>
                <div className="portlet mt-3 mb-4 pt-0">
                    <div className="portlet__body">
                        <div className="row">
                            <div className="col-12 col-md-6 mb-4">
                                <label htmlFor="first_name" className="form-label">{t('FirstName')}</label>
                                <input type="text" id="first_name" name="first_name" className="form-control " required={true} pattern="^[^&lt;&gt;±!@£$%^&amp;_+§¡€#¢§¶•ªº«\/\\&lt;&gt;?:;\|=.,]{1,50}$" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                <div className="invalid-feedback">{t('FirstNameRequired')}</div>
                            </div>
                            <div className="col-12 col-md-6 mb-4">
                                <label htmlFor="last_name" className="form-label">{t('LastName')}</label>
                                <input type="text" id="last_name" name="last_name" className="form-control " required={true} pattern="^[^&lt;&gt;±!@£$%^&amp;_+§¡€#¢§¶•ªº«\/\\&lt;&gt;?:;\|=.,]{1,50}$" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                <div className="invalid-feedback">{t('LastNameRequired')}</div>
                            </div>
                            <div className="col-12 col-md-6 mb-4">
                                <label htmlFor="language" className="form-label">{t('Language')}</label>
                                <select id="language" name="language"
                                    onChange={(e) => setLanguage(e.target.value)}
                                    value={language}
                                    className="form-select" required>
                                    <option value="en">English
                                    </option>
                                    <option value="vi" style={{ fontFamily: 'Roboto, sans-serif' }}>Tiếng Việt
                                    </option>
                                </select>
                            </div>
                            <div className="col-12 col-md-6">
                                <label htmlFor="time_zone" className="form-label">{t('TimeZone')}</label>
                                <select id="time_zone" name="time_zone" className="form-select" value={timeZone}
                                    onChange={(e) => setTimeZone(e.target.value)}>
                                    {timeZones.map((zone) => (
                                        <option key={zone.value} value={zone.value}>
                                            {zone.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center mb-5">
                    <button id="submit-account-information" type="submit" className="btn btn-primary col-8 mb-3 col-md-4 mx-md-3 my-md-0" onClick={handleSubmit}>{t('Save')}</button>
                </div>
                <div className="footer mb-5 mb-md-auto">
                    <div className="row my-4 small">
                        <div className="col-12 small text-center text-md-end mb-md-1 mb-2 fw-bold">
                            <a href="#" id="ftmo-cookie-settings" className=""> {t('CookieSettings')} </a>
                            &nbsp;
                            <a href="#" data-bs-toggle="modal" data-bs-target="#modal_privacy_policy"> {t('PrivacyPolicy')} </a>
                            &nbsp;
                            <a href="#" id="footer__link-terms-conditions">{t('TermsConditions')}</a>
                        </div>

                        <div className="col-12 small">
                            <div className="col-12 small">
                                <p className="text-justify">
                                    {t('disclaimerFull')}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        </Layout>
    );
}

export default AccountInfoPage;